export const SCATTER_CHART_CATEGORY_KEY = 'charting' as const;
export const SCATTER_CHART_COMPONENT_KEY = 'scatterChart' as const;
